import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderButton from '@components/HeaderButton';
import { Column } from '@cards/Card';
import { usePageActions, useTitleUpdate } from '@hooks';
import FlagsListCard from '@cards/Flags/List';
import { historyType, matchType } from '../../../propTypes';

function List({ history, match }) {
  const { t } = useTranslation();
  const { setTitle } = usePageActions({
    title: t('flags:List.title'),
    actions: [
      <HeaderButton
        key="flags-view-disabled"
        tooltip={t('flags:List.viewDisabled')}
        onClick={() => history.push(`${match.path}/disabled`)}
      >
        {t('flags:List.viewDisabled')}
      </HeaderButton>,
      <HeaderButton
        key="flags-new"
        tooltip={t('flags:List.new')}
        onClick={() => history.push(`${match.path}/new`)}
      >
        {t('flags:List.new')}
      </HeaderButton>,
    ],
  });
  document.title = t('flags:List.title');
  useTitleUpdate(setTitle, 'flags:List.title');

  return (
    <Column>
      <FlagsListCard />
    </Column>
  );
}

List.propTypes = {
  history: historyType.isRequired,
  match: matchType.isRequired,
};

export default List;
